<template>
  <article class="d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <small>{{ translate('Items per page') }}:</small>
      <BootstrapDropdown class="px-2">
        <template #toggle>
          <BootstrapButton
            variant="secondary"
            class="dropdown-toggle"
            data-bs-toggle="dropdown"
            outlined
            size="sm"
            :aria-label="translate('Limit per page')"
          >
            {{ props.limit }}
          </BootstrapButton>
        </template>
        <template #items>
          <button
            v-for="option in pageLimitOptions"
            :key="option"
            type="button"
            class="dropdown-item text-wrap w-100 controls"
            :aria-label="`Set limit to ${option}`"
            @click="$emit('update:page-limit', option)"
          >
            {{ option }}
          </button>
        </template>
      </BootstrapDropdown>
      <small>
        {{ (currentPage - 1) * props.limit + 1 }} -
        {{ Math.min(currentPage * props.limit, props.total) }}
        {{ translate('of') }} {{ props.total }} items
      </small>
    </div>
    <BootstrapPagination
      :count="count"
      :page="page"
      @update:page="(value: number) => $emit('update:page', value)"
    />
  </article>
</template>

<script lang="ts" setup>
const props = defineProps<{
  count: number;
  total: number;
  page: number;
  limit: number;
}>();

const {translate} = useLocalisation();

defineEmits(['update:page', 'update:page-limit']);

const pageLimitOptions = ref([25, 50, 75, 100]);
const currentPage = ref(props.page || 1);

watch(
  () => props.page,
  () => {
    currentPage.value = props.page || 1;
  },
  {immediate: true},
);
</script>
